import React from "react";
import Layout from "../../components/layout";
import MainBanner from "../../components/po-case-study/page-main-banner";
import Intro from "../../components/po-case-study/cs-intro";
import Challenge from "../../components/po-case-study/cs-challenge";
import Process from "../../components/po-case-study/po-process";
import Dashboard from "../../components/po-case-study/po-dashboard";
import Testimonial from "../../components/po-case-study/po-testimonial";
import WorkFlow from "../../components/po-case-study/po-workflow";
import Progress from "../../components/po-case-study/po-progress";
import Impact from "../../components/po-case-study/po-impact";
import SEO from '../../components/seo';
import StickyCTA from "../../components/common/templates/sticky-cta-section";


function PhysioOutcomeCaseStudy({ location }) {

  return (
    <Layout addBodyClass="PhysioOutcome-case-study-page-template transparent-header" footerFormType="basic">
      <SEO description="How Rapidops helped healthcare unicorn digitally innovate and automate patient experience?"
        meta={[{ name: "charSet", content: "utf-8" }]}
        title="Personalized and Automated Patient Experience" />
      <MainBanner />
      <Intro />
      <Challenge />
      <Process />
      <Dashboard />
      <Testimonial />
      <WorkFlow />
      <Progress />
      <Impact /> 
      {/* <StickyCTA /> */}
    </Layout>

  );
}


export default PhysioOutcomeCaseStudy;
